<form
    [formGroup]="userForm"
    (ngSubmit)="onSubmit()"
    name="child-proof-of-identity-form"
>
    <div class="row">
        <div class="col-md-6">
            <div class="form-group bg-policy">
                <p>The information provided must match exactly with your Proof of Identity Document that is presented on the day of the {{testTypeName}}.</p>
                <p *ngIf="brandId !== BrandEnum.CELPIP">If this information does not match, you will not be permitted to take the {{testTypeName}} and your {{testTypeName}} fee will be forfeited.</p>
                <p *ngIf="brandId === BrandEnum.CELPIP">If your name and date of birth do not match exactly, you may be refused entry to the test and will not be able to receive a refund or transfer.</p>
            </div>
            <div class="form-group">
                <div style="margin-bottom: 20px;"><span class="required fa fa-asterisk"></span> Indicates required fields.</div>
            </div>

            <div class="form-group">
                <label>Country of Citizenship (or Country Issuing Passport) <span class="required fa fa-asterisk"></span></label>
                <select
                    id="proof-of-identity-country-select"
                    class="form-control"
                    name="citizenshipCountryId"
                    formControlName="citizenshipCountryId"
                >
                    <option
                        *ngFor="let country of personalLookupInfo.countries"
                        [ngValue]="country.id"
                    >
                        {{country.name}}
                    </option>
                </select>
                <small
                    class="error"
                    *ngIf="f.citizenshipCountryId.dirty && f.citizenshipCountryId.errors?.required"
                >Please enter your country.</small>
            </div>
            <div class="form-group">
                <label>First/Given Name <span class="required fa fa-asterisk"></span></label>
                <input
                    id="proof-of-identity-first-name-input"
                    type="text"
                    class="form-control"
                    name="firstName"
                    formControlName="firstName"
                    [readonly]="true"
                />
                <small
                    class="error"
                    *ngIf="f.firstName.dirty && f.firstName.errors?.required"
                >Please enter your first name.</small>
                <small
                    class="error"
                    *ngIf="f.firstName.errors?.pattern"
                >Only English characters are accepted.</small>
            </div>
            <div class="form-group">
                <label>Middle Name</label>
                <input
                    id="proof-of-identity-middle-name-input"
                    type="text"
                    class="form-control"
                    name="middleName"
                    formControlName="middleName"
                />
                <small
                    class="error"
                    *ngIf="f.middleName.errors?.pattern"
                >Only English characters are accepted.</small>
            </div>
            <div class="form-group">
                <label>Last/Family Name <span class="required fa fa-asterisk"></span></label>
                <input
                    id="proof-of-identity-last-name-input"
                    type="text"
                    class="form-control"
                    name="lastName"
                    formControlName="lastName"
                    [readonly]="true"
                />
                <small
                    class="error"
                    *ngIf="f.lastName.dirty && f.lastName.errors?.required"
                >Please enter your last name.</small>
                <small
                    class="error"
                    *ngIf="f.lastName.errors?.pattern"
                >Only English characters are accepted.</small>
            </div>
            <div class="form-group">
                <label>First Language <span class="required fa fa-asterisk"></span></label>
                <select
                    id="proof-of-identity-first-language-select"
                    class="form-control"
                    name="firstLanguage"
                    formControlName="firstLanguageId"
                >
                    <option
                        *ngFor="let language of personalLookupInfo.languages"
                        [ngValue]="language.id"
                    >
                        {{language.name}}
                    </option>
                </select>
                <small
                    class="error"
                    *ngIf="f.firstLanguageId.dirty && f.firstLanguageId.errors?.required"
                >Please enter your a language.</small>
            </div>

            <div class="form-group">
                <label class="control-label">Birthday <span class="required fa fa-asterisk"></span></label>
                <input
                    type="date"
                    max="{{today | date:'yyyy-MM-dd'}}"
                    class="form-control"
                    formControlName="birthDate"
                    name="birthday"
                    placeholder="Click to select"
                    (change)="checkBirthDateValidity()"
                    [ngClass]="{ 'is-invalid': f.birthDate.dirty && f.birthDate.errors?.required }"
                    [readonly]="true"
                />
                <small
                    class="error"
                    *ngIf="f.birthDate.dirty && f.birthDate.errors?.required"
                >Please enter a birth date.</small>
                <small
                    class="error"
                    *ngIf="showBirthDateError"
                >Please enter a valid birth date.</small>
            </div>

            <div class="form-group">

                <label>Gender <span class="required fa fa-asterisk"></span></label>
                <select
                    id="proof-of-identity-gender-select"
                    class="form-control"
                    name="gender"
                    formControlName="gender"
                >
                    <option value="F">Female</option>
                    <option value="M">Male</option>
                    <option value="X">X</option>
                </select>
                <small
                    class="error"
                    *ngIf="f.gender.dirty && f.gender.errors?.required"
                >Please enter your gender.</small>
            </div>
        </div>

        <div class="col-md-6">
            <div class="bg-policy">
                <p class="highlight">
                    IMPORTANT: Test takers who do not bring an acceptable identity document will be refused entry and will not be eligible for a refund or test transfer accommodation.<br><br>
                    Please enter your name, date of birth, identity document number, and expiry date exactly as shown on your identification document.
                </p>
                <h5>IDENTIFICATION DOCUMENT NEEDS TO BE:</h5>
                <ul>
                    <li>Valid</li>
                    <li>Unexpired</li>
                    <li>Original (Photocopies are unacceptable)</li>
                </ul>
            </div>
            <br />
            <div
                class="bg-policy"
                *ngIf="brandId === BrandEnum.CAEL"
            >
                <article>
                    Only the identification documents listed below are accepted for the CAEL Test: <br><br>
                    <ul>
                        <li>a valid Chinese Second Generation Resident ID Card for tests in <b>CHINA</b></li>
                        <li>a piece of photo identification issued by a government agency within Canada for tests in <b>CANADA</b></li>
                    </ul>
                </article>
            </div>
            <br />
            <div class="form-group">
                <label>Identity Document Type <span class="required fa fa-asterisk"></span></label>
                <select
                    id="proof-of-identity-document-type-select"
                    class="form-control"
                    name="idDocType"
                    formControlName="idDocTypeId"
                >
                    <option
                        *ngFor="let idDocType of personalLookupInfo.idDocTypes"
                        [ngValue]="idDocType.id"
                    >
                        {{idDocType.name}}
                    </option>
                </select>
                <small
                    class="error"
                    *ngIf="f.idDocTypeId.dirty && f.idDocTypeId.errors?.required"
                >Please select a document type.</small>
            </div>
            <div
                class="form-group"
                *ngIf="f.idDocTypeId.value == IdDocTypeEnum.CanadianTravelDocument"
            >
                <!-- Travel Document Note -->
                <article
                    class="bg-policy"
                    style="padding: 1em;"
                >
                    A Travel Document refers to the following documents specifically:
                    <ul>
                        <li>Refugee Travel Document</li>
                        <li>Travel Document in lieu of passport</li>
                        <li>Certificate of Identity</li>
                    </ul>
                    It does NOT refer to the following, and these are not accepted for the {{brandName}} Test:
                    <ul>
                        <li>NEXUS Card</li>
                        <li>Work Permit</li>
                        <li>Record of Landing</li>
                        <li>Interim Federal Health Certificate of Eligibility</li>
                        <li>Enhanced Driver's License</li>
                    </ul>
                </article>
            </div>
            <div
                class="form-group"
                *ngIf="f.idDocTypeId.value == IdDocTypeEnum.CertificateofIdentity"
            >
                <article
                    class="bg-policy"
                    style="padding: 1em;"
                >
                    A certificate of identity is the name of a specific document issued by a country to non-citizens residing within their borders who are stateless persons or otherwise unable to obtain a national passport. Driver's licences and identification cards are examples of documents that are <u><strong><span style="color: #A6192E;">not</span></strong></u> certificates of identity.
                </article>
            </div>
            <div
                class="form-group"
                *ngIf="f.idDocTypeId.value == IdDocTypeEnum.ProvincialIdentificationCard"
            >
                <article
                    class="bg-policy"
                    style="padding: 1em;"
                >
                    Please note that Canadian health cards are not accepted.
                </article>
            </div>
            <div
                class="form-group"
                *ngIf="f.idDocTypeId.value == IdDocTypeEnum.CertificateOfIndianStatus"
            >
                <article
                    class="bg-policy"
                    style="padding: 1em;"
                >
                    Both the Secure Certificate of Indian Status and the Certificate of Indian Status will be accepted.
                </article>
            </div>
            <div
                class="form-group"
                *ngIf="f.idDocTypeId.value == IdDocTypeEnum.ChinaResidentIDCard"
            >
                <article
                    class="bg-policy"
                    style="padding: 1em;"
                >
                    Please note that the Hong Kong ID Card is <strong>NOT</strong> accepted for the {{brandName}} Test.
                </article>
            </div>
            <div class="form-group">
                <label>Document Number <span class="required fa fa-asterisk"></span></label>
                <input
                    id="proof-of-identity-document-number-input"
                    type="text"
                    class="form-control"
                    name="idDocNum"
                    formControlName="idDocNumber"
                    maxlength="40"
                />
                <small
                    class="error"
                    *ngIf="f.idDocNumber.dirty && f.idDocNumber.errors?.required"
                >Please enter a document number.</small>
                <small
                    class="error"
                    *ngIf="f.idDocNumber.dirty && f.idDocNumber.errors?.pattern"
                >The Document Number is not accepted because it contains special characters (!#$%&*+,-./). This field only accepts alphabetic (Aa to Zz) or numeric (0 to 9) characters.</small>
            </div>
            <div class="form-group">
                <label class="control-label">Expiry Date <span class="required fa fa-asterisk"></span></label>
                <input
                    *ngIf="f.idDocTypeId.value != IdDocTypeEnum.CanadianRefugeeProtectionClaimantDocument"
                    type="date"
                    min="{{today | date:'yyyy-MM-dd'}}"
                    max="9999-12-31"
                    class="form-control"
                    name="idDocDate"
                    formControlName="idDocExpiryDate"
                    placeholder="Click to select"
                    (change)="checkExpiryDateValidity()"
                    [ngClass]="{ 'is-invalid': f.idDocExpiryDate.dirty && f.idDocExpiryDate.errors?.required }"
                />
                <input
                    *ngIf="f.idDocTypeId.value == IdDocTypeEnum.CanadianRefugeeProtectionClaimantDocument"
                    type="date"
                    min="{{1900-01-01 | date:'yyyy-MM-dd'}}"
                    class="form-control"
                    name="idDocDate"
                    formControlName="idDocExpiryDate"
                    placeholder="Click to select"
                    (change)="checkExpiryDateValidity()"
                    [ngClass]="{ 'is-invalid': f.idDocExpiryDate.dirty && f.idDocExpiryDate.errors?.required }"
                />
                <small
                    class="error"
                    *ngIf="f.idDocExpiryDate.dirty && f.idDocExpiryDate.errors?.required"
                >Please enter a document expiry date.</small>
                <small
                    class="error"
                    *ngIf="showIdDocExpiryError"
                >Please enter a valid document expiry date.</small>
            </div>
        </div>
    </div>
    <button
        type="submit"
        class="btn btn-primary"
        name="confirmationYesBtn"
    >
        Save Personal Information
    </button>
</form>
